import {CrudFilters, IResourceComponentsProps, useList, useTranslate} from '@refinedev/core';

import {
    DateField,
    List, TagField,
    useTable,
} from '@refinedev/antd';

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import {AutoComplete, Button, Col, DatePicker, Form, Input, Popover, Row, Select, Space, Table} from 'antd';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {StoreContext} from '../../contexts/StoreContext';
import dayjs from 'dayjs';

export const ReportMovimentazioniList: React.FC<IResourceComponentsProps> = () => {
    const {value, value2, value4} = useContext(StoreContext);
    const [store, setStore] = value;
    const [espositore, setEspositore] = value4;
    const [form] = Form.useForm();
    const [searchValue, setSearchValue] = useState<string>('');
    const [debouncedValue, setDebouncedValue] = useState<string>('');
    const [selectedCodice, setSelectedCodice] = useState<string | null>(null);
    const [snapshotQuery, setSnapshotQuery] = useState<{ date: string; codice: string; description?: string } | null>(null);
    const [selectedDescription, setSelectedDescription] = useState<string | null>(null);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(searchValue), 300);
        return () => clearTimeout(timer);
    }, [searchValue]);

    const { data: productsData } = useList<any>({
        resource: 'products',
        meta: { populate: 'barcodes' },
        pagination: { pageSize: 15 },
        filters: [
            {
                operator: 'or',
                value: [
                    { field: 'description', operator: 'contains', value: debouncedValue },
                    { field: 'barcodes][code]', operator: 'contains', value: debouncedValue },
                    { field: 'codice', operator: 'contains', value: debouncedValue },
                ],
            },
        ],
        queryOptions: {
            enabled: debouncedValue.length >= 2,
        },
    });

    const autoCompleteOptions = (productsData?.data || []).map((p: any) => {
        const firstBarcode = p.barcodes && p.barcodes.length > 0 ? p.barcodes[0].code : '';
        const label = firstBarcode ? `${p.description} — ${firstBarcode}` : p.description;
        return { value: p.description, label, codice: p.codice };
    });

    const { data: turnSnapshotData } = useList<any>({
        resource: 'turns',
        pagination: { pageSize: 1 },
        sorters: [{ field: 'dataOut', order: 'desc' }],
        filters: [
            { field: 'seller][id]', operator: 'eq', value: store?.id },
            { field: 'dataOut', operator: 'lte', value: snapshotQuery ? `${snapshotQuery.date} 23:59:59` : undefined },
            { field: 'dataOut', operator: 'null', value: false },
        ],
        queryOptions: {
            enabled: !!snapshotQuery,
        },
    });

    useEffect(() => {
        if (!snapshotQuery || !turnSnapshotData?.data?.[0]) return;
        const turn = turnSnapshotData.data[0];
        const snap = turn.snapshotStock;
        console.log('[GIACENZA] turn found:', turn.id, 'dataOut:', turn.dataOut);
        console.log('[GIACENZA] looking for codice:', snapshotQuery.codice, 'description:', snapshotQuery.description);
        console.log('[GIACENZA] snapshotStock keys:', snap ? Object.keys(snap) : 'NO SNAPSHOT');

        const buckets = [
            { name: 'priceCategoryEspositore', list: snap?.priceCategoryEspositore || [] },
            { name: 'priceCategoryMagazzino', list: snap?.priceCategoryMagazzino || [] },
        ];

        for (const bucket of buckets) {
            for (const cat of bucket.list) {
                const child = (cat.children || []).find((c: any) =>
                    String(c.codice) === String(snapshotQuery.codice) ||
                    (snapshotQuery.description && c.description && String(c.description).trim().toLowerCase() === String(snapshotQuery.description).trim().toLowerCase())
                );
                if (child) {
                    console.log('[GIACENZA] match in', bucket.name, '/', cat.category, '→ qta:', child.qta, child);
                    form.setFieldsValue({ giacenza: String(child.qta) });
                    return;
                }
            }
        }
        console.log('[GIACENZA] no match in snapshot, sample espositore:', snap?.priceCategoryEspositore?.[0]?.children?.[0]);
        form.setFieldsValue({ giacenza: '0' });
    }, [turnSnapshotData, snapshotQuery]);
    const {tableProps, searchFormProps, tableQueryResult} = useTable<any>({
        syncWithLocation: false,
        resource: "custom/reportBarcodes",
        pagination: {
            pageSize: 9999999,
            mode: "server"
        },
        queryOptions: {
          enabled: true
        },
        onSearch: (params: any) => {
            console.log(params);
            const filters: CrudFilters = [];
            filters.push(
                {
                    field: 'barcode',
                    operator: 'eq',
                    value: (params?.description) ? params?.description : '0'
                },
                {
                    field: 'description',
                    operator: 'eq',
                    value: (params?.description) ? params?.description : '',
                },
                {
                    field: 'daData',
                    operator: 'eq',
                    value: (params?.daData) ? dayjs(params?.daData).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
                },
                {
                    field: 'giacenza',
                    operator: 'eq',
                    value: (params?.giacenza) ? params?.giacenza : 0,
                }
            );
            // tableQueryResult.refetch();
            return filters;
        },
        filters: {
            permanent: [
                {
                    field: 'seller][id]',
                    operator: 'eq',
                    value: store.id
                },
                {
                    field: 'espositore',
                    operator: 'eq',
                    value: espositore
                }
            ]
        },
        sorters: {
            permanent: [
                {
                    field: 'createdAt',
                    order: 'desc'
                }
            ]
        }
    });

    return (
            <List
                title={'Report Barcode'}
                headerProps={{
                    extra: [
                        // <Form form={form} layout="horizontal" {...searchFormProps} labelCol={{span: 8}}
                        //       wrapperCol={{span: 24}}>
                        //     <Row gutter={24}>
                        //         <Col span={4}>
                        //             <Form.Item label="Barcode" name="description">
                        //                 <Input
                        //                     onPressEnter={form.submit}
                        //                     allowClear={true}
                        //                     placeholder="Cerca"
                        //                     prefix={<Icons.SearchOutlined/>}
                        //                 />
                        //             </Form.Item>
                        //         </Col>
                        //         <Col span={4}>
                        //             <Form.Item label={'Data'} name={'daData'}>
                        //                 <DatePicker
                        //                     style={{width: '100%'}}
                        //                     format={'DD-MM-YYYY'}
                        //                     placeholder={'da data...'}
                        //                 />
                        //             </Form.Item>
                        //         </Col>
                        //         <Col span={4}>
                        //             <Form.Item label={'Giacenza'} name={'giacenza'}>
                        //                 <Input
                        //                     onPressEnter={form.submit}
                        //                     allowClear={true}
                        //                     placeholder="Giacenza"
                        //                 />
                        //             </Form.Item>
                        //         </Col>
                        //     </Row>
                        // </Form>
                    ],
                }}
            >
                <hr />
                <Form {...searchFormProps} form={form} layout="horizontal"
                      onValuesChange={(changed) => {
                          if ('daData' in changed && changed.daData && (selectedCodice || selectedDescription)) {
                              setSnapshotQuery({
                                  date: dayjs(changed.daData).format('YYYY-MM-DD'),
                                  codice: selectedCodice ?? '',
                                  description: selectedDescription ?? undefined,
                              });
                          }
                      }}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item label="Barcode / Descrizione" name="description">
                            <AutoComplete
                                options={autoCompleteOptions}
                                onSearch={(text) => setSearchValue(text)}
                                onSelect={(val, option: any) => {
                                    form.setFieldValue('description', val);
                                    setSelectedCodice(option?.codice ?? null);
                                    setSelectedDescription(val);
                                    const currentDate = form.getFieldValue('daData');
                                    if (currentDate) {
                                        setSnapshotQuery({
                                            date: dayjs(currentDate).format('YYYY-MM-DD'),
                                            codice: option?.codice ?? '',
                                            description: val,
                                        });
                                    }
                                }}
                                onClear={() => {
                                    setSelectedCodice(null);
                                    setSelectedDescription(null);
                                    setSnapshotQuery(null);
                                }}
                                allowClear={true}
                                placeholder="Barcode o descrizione..."
                                filterOption={false}
                            >
                                <Input
                                    onPressEnter={form.submit}
                                    prefix={<Icons.SearchOutlined/>}
                                />
                            </AutoComplete>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item label={'Data'} name={'daData'}>
                            <DatePicker
                                style={{width: '100%'}}
                                format={'DD-MM-YYYY'}
                                placeholder={'da data...'}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item label={'Giacenza'} name={'giacenza'}>
                            <Input
                                onPressEnter={form.submit}
                                allowClear={true}
                                placeholder="Giacenza"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Button type="primary" htmlType="submit" >Conferma</Button>
                    </Col>
                </Row>
                </Form>
                <Row gutter={24}>
                    <Col span={24}>
                        <Table {...tableProps}
                            size={'small'}
                               scroll={{y: window.innerHeight - 330 + 'px'}}
                               pagination={false}
                               footer={(data) => {
                                   const counts: Record<string, number> = {};
                                   (data as any[]).forEach((r: any) => {
                                       const tipo = r.is_deleted ? 'VENDITA CANCELLATA' : r.tipo;
                                       if (!tipo) return;
                                       counts[tipo] = (counts[tipo] || 0) + 1;
                                   });
                                   const colorFor = (tipo: string) => {
                                       if (tipo === 'VENDITA CANCELLATA') return 'violet';
                                       if (tipo === 'CARICO DDT') return 'gray';
                                       if (tipo === 'RIASSORTIMENTO ANTICIPATO') return 'red';
                                       if (tipo === 'RIASSORTIMENTO') return 'cornflowerblue';
                                       if (tipo === 'VARIAZIONE REFERENZA') return 'yellow';
                                       if (tipo === 'REFERENZA SU ESPOSITORE DEFAULT') return 'orange';
                                       return 'green';
                                   };
                                   const total = (data as any[]).length;
                                   return (
                                       <Space wrap>
                                           <strong style={{ marginRight: 12 }}>Riepilogo:</strong>
                                           {Object.entries(counts)
                                               .sort((a, b) => b[1] - a[1])
                                               .map(([tipo, count]) => (
                                                   <TagField
                                                       key={tipo}
                                                       value={`${tipo}: ${count}`}
                                                       color={colorFor(tipo)}
                                                   />
                                               ))}
                                       </Space>
                                   );
                               }}
                        >
                            <Table.Column
                                dataIndex={'id'}
                                title={'ID'}
                                key={'id'}
                            />
                            <Table.Column
                                dataIndex={'codice'}
                                title={'AMS'}
                                key={'codice'}
                            />
                            <Table.Column
                                dataIndex={'description'}
                                title={'Descrizione'}
                                key={'description'}
                            />
                            <Table.Column
                                dataIndex={'position'}
                                title={'Posizione'}
                                key={'position'}
                            />
                            <Table.Column
                                dataIndex={'doc_number'}
                                title={'Numero Documento'}
                                key={'doc_number'}
                            />
                            <Table.Column
                                dataIndex={'created_at'}
                                key={'created_at'}
                                title={'Data'}
                                render={(value, record: any) => (
                                    <DateField value={value} format={'DD-MM-YYYY - HH:mm:ss'} />
                                )}
                            />
                            <Table.Column
                                dataIndex={'tipo'}
                                key={'tipo'}
                                title={'Tipo'}
                                render={(value, record: any) => (
                                    <TagField value={record.is_deleted ? 'VENDITA CANCELLATA' : value} style={{
                                        color: (value === 'VENDITA' && record.is_deleted) ? 'violet' : value === 'CARICO DDT' ? 'gray' : value === 'RIASSORTIMENTO ANTICIPATO' ? 'red' : value === 'RIASSORTIMENTO' ? 'cornflowerblue' : value === 'VARIAZIONE REFERENZA' ? 'yellow' :  value === 'REFERENZA SU ESPOSITORE DEFAULT' ? 'orange' : 'green'
                                    }} />
                                )}
                            />
                            <Table.Column
                                dataIndex={'progressivo'}
                                key={'progressivo'}
                                title={'Progressivo'}
                                render={(value, record: any) => (
                                    value
                                )}
                            />
                            <Table.Column
                                dataIndex={'giacenza'}
                                key={'giacenza'}
                                title={'Giacenza'}
                                render={(value, record: any) => {

                                    return(
                                        Number(value)
                                    )
                                }}
                            />
                        </Table>
                    </Col>
                </Row>
            </List>
    );
};
